import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/Invoice/Invoice/node_modules/next/dist/client/app-dir/link.js");
